import { Link } from "react-router-dom";
import { Scale, ArrowUpRight, FileCheck2, Gavel } from "lucide-react";

export const Attorneys = () => {
  return (
    <section id="attorneys" className="relative py-20 sm:py-24 md:py-36 btr-bg-graphite" data-testid="attorneys-section">
      <div className="absolute inset-0 btr-grid opacity-25" />
      <div className="btr-beam btr-beam-drift" style={{ width: 500, height: 500, bottom: "-10%", left: "-10%", background: "#a2020b", opacity: 0.2 }} />

      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="btr-reveal">
          <span className="btr-badge">
            <span className="dot" />
            For Legal Professionals
          </span>
          <h2 className="font-display font-extrabold text-white text-3xl sm:text-5xl lg:text-[3.25rem] mt-6 leading-[1.05] tracking-tight">
            Built for attorneys who need documentation that <span className="text-[#a2020b]">holds up</span>.
          </h2>
          <p className="font-body text-zinc-400 text-base sm:text-lg mt-6 leading-relaxed">
            Before The Risk supports attorneys with organized, defensible, and strategically structured
            documentation for insurance disputes, property risk, liability questions, and pre-loss intelligence.
          </p>

          <Link to="/contact" className="btr-btn-primary mt-9" data-testid="attorneys-cta">
            <Scale className="w-4 h-4" />
            Partner With Before The Risk
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="btr-reveal grid sm:grid-cols-2 gap-4">
          {[
            { icon: FileCheck2, t: "Defensible Reports", d: "Structured to survive cross-examination." },
            { icon: Gavel, t: "Courtroom-Ready", d: "Format aligned for trial, mediation, arbitration." },
            { icon: Scale, t: "Liability Clarity", d: "Traced causation and responsibility mapping." },
            { icon: FileCheck2, t: "Pre-Loss Intel", d: "Anticipate disputes before they escalate." },
          ].map((c, i) => {
            const Icon = c.icon;
            return (
              <div key={c.t} className="btr-glass rounded-lg p-5 hover:border-[#a2020b]/45 transition-colors">
                <Icon className="w-5 h-5 text-[#a2020b]" strokeWidth={1.5} />
                <div className="font-display font-bold text-white text-base mt-4">{c.t}</div>
                <div className="font-body text-zinc-500 text-sm mt-2">{c.d}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
